import { Container } from "inversify";

export const servicesContainer = new Container();
